module.exports = __webpack_public_path__ + "img/dinheiro.a11ea2ac.svg";